import { useTranslate } from "@customer_interactions/i18n";

const useTranslation = (key: string) => {
  const t = useTranslate();
  return t(key);
};

export default useTranslation;
